// extracted by mini-css-extract-plugin
export default {"inputContainer":"IEp9mmdRMcbhIF6d8Xwb","labelContainer":"JiE_bwQvAmaznaBss3tN","inputDescription":"RWkGwKQlE8HDxOhn2jnP","inputCurrency":"EZkA6PsJ61sfrTQFS0WQ"};